import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { DocumentName } from "@components/documents/DocumentName";
import { HistoryDocumentDetailsBaseRow } from "../utils/historyDocumentDetailsRow";

interface HistoryDocumentFileCellProps {
    row: { original: HistoryDocumentDetailsBaseRow };
}

export const HistoryDocumentFileCell = memo(
    ({ row }: HistoryDocumentFileCellProps) => {
        const { fileName, resourceId } = row.original;

        if (!fileName) {
            return (
                <ViewTableCell>
                    <EmptyValue />
                </ViewTableCell>
            );
        }

        return (
            <ViewTableCell>
                <DocumentName
                    fileName={fileName}
                    icon
                    documentId={resourceId}
                />
            </ViewTableCell>
        );
    },
);

HistoryDocumentFileCell.displayName = "HistoryDocumentFileCell";
